/* eslint-disable react-hooks/exhaustive-deps */
import { ChangeEvent, useEffect, useState } from "react";
import { useAuth } from "src/hooks/auth";
import { api } from "src/services/api";
import { Container, Content } from "./styles";
import "./style.css";
import { Trash2 } from "lucide-react";
import {
	ModalClose,
	ModalContainer,
	ModalContent,
	ModalRoot,
} from "src/components/ui/modal";
import { ModalLoader } from "src/components/modalLoader";
import { OTPInputPassword } from "src/components/OTPInputPassword";
import { setAuthToken } from "src/utils/setAuthToken";
import { isAxiosError } from "src/utils/isAxiosError";
import { showAlertError } from "src/components/alertError";
import successNewPixTransaction from "src/assets/successNewPixTransaction.svg";
import { dateFormat } from "src/utils/dateFormat";

// type TransactionData = {
//   id: string;
//   description: string;
//   serialNum: string;
//   status: string;
// };

// interface ContactProps {
// 	id: string;
// 	contactName: string;
// 	keyPix: string;
// 	keyType: string;
// }

export interface DevicesProps {
	id: string;
	user_id: null;
	graphic_id: string;
	device: {
		browser: string;
		os: string;
	};
	allowed: boolean;
	isDeleted: boolean;
	created_at: string;
}

// const fakeData: TransactionData[] = [
// 	{ id: "1", description: "Máquina A", serialNum: "12345", status: "Ativo" },
// 	{ id: "2", description: "Máquina B", serialNum: "67890", status: "Inativo" },
// 	{ id: "3", description: "Máquina C", serialNum: "54321", status: "Ativo" },
// 	{ id: "4", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "5", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "6", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "7", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "8", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "9", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "10", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// ];

export function AutorizedDevicesList() {
	const token = localStorage.getItem("@stricv2:token");
	const [data, setData] = useState<DevicesProps[]>([]);
	const [id, setId] = useState<string>("");
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [otp, setOtp] = useState<string[]>([]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [step, setStep] = useState(1);
	const { account } = useAuth();
	// const [contacts, setContacts] = useState<ContactProps[]>([]);

	// const fetchCurrentDevices = async () => {
	//   try {
	//     // Substituindo a chamada à API por dados fictícios
	//     const { data: responseData } = await api.get(`/devices`, {
	//       headers: { Authorization: `Bearer ${token}` },
	//     });
	//     setData(responseData);

	//      console.log("Usando dados fictícios", data);
	//     // setData(fakeData);
	//   } catch (error) {
	//     console.error("Erro ao buscar os dados:", error);
	//   }
	// };

	const fetchDevices = async () => {
		try {
			// Substituindo a chamada à API por dados fictícios
			const { data: responseData } = await api.get(`/devices`, {
				headers: { Authorization: `Bearer ${token}` },
			});
			// Transformar o objeto em um array, caso seja um único item
			const deviceArray = Array.isArray(responseData)
				? responseData
				: [responseData];
			setData(deviceArray);

			console.log("Dados recebidos:", deviceArray);
		} catch (error) {
			console.error("Erro ao buscar os dados:", error);
		}
	};

	useEffect(() => {
		fetchDevices();
	}, []);

	// const fetchContacts = async () => {
	//       try {
	//           let url = `/pix/favorites`;
	//           const { data } = await api.get<ContactProps[]>(url, {
	//               headers: { Authorization: "Bearer " + token },
	//           });

	//           setContacts(data);
	//       } catch (error) {
	//           console.error("Error fetching contacts:", error);
	//       }
	//   };

	const handleDeleteContact = async (id: string) => {
		setId(id);
		setIsModalOpen(true);
	};

	const handleOTPPinChange = (
		e: ChangeEvent<HTMLInputElement>,
		index: number,
	) => {
		setOtp((prevValues) => {
			const updatedValues = [...prevValues];
			updatedValues[index] = e.target.value;
			return updatedValues;
		});
	};

	const onCompletePin = async (pin: string) => {
		setIsSubmitting(true);
		try {
			setAuthToken();
			await api.delete("/device", {
				data: { id, pin },
			});
			setStep(2);
			fetchDevices();
		} catch (error) {
			if (isAxiosError(error) && error.response) {
				const errorMessage = (error.response.data as { message: string })
					.message;
				showAlertError(errorMessage);
			} else {
				showAlertError("Ocorreu um erro inesperado.");
			}
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Container className="w-full">
			<Content className="w-full h-full padding-container items-center justify-center">
				<div className="flex flex-col items-center justify-center w-full px-[2%]">
					<span className="title-text">Lista de Dispositivos Autorizados:</span>

					<div className="w-full">
						<div className="flex justify-between items-center mb-8">
							<div>
								<h3 className="title-text">
									Total de Dispositivos:{" "}
									<span className="font-bold text-[#AA7339]">
										{data.length}
									</span>
								</h3>
							</div>
						</div>

						<div className="flex flex-col rounded-lg bg-white w-full height-table">
							<table className="w-full border-collapse border-none">
								<thead className="bg-gray-100">
									<tr className="text-center font-semibold">
										<th className="table-title text-center align-middle text-gray-700 bg-gray-100">
											Nome do Dispositivo
										</th>
										<th className="table-title text-center align-middle text-gray-700 bg-gray-100">
											Navegador de Origem
										</th>
										<th className="table-title text-center align-middle text-gray-700 bg-gray-100">
											Data e Hora
										</th>
										<th className="table-title text-center align-middle text-gray-700 bg-gray-100">
											Deletar Dispositivo
										</th>
									</tr>
								</thead>
							</table>
							<div className="overflow-y-auto h-full">
								<table className="w-full border-collapse border-none">
									<tbody>
										{data.map((devices) => (
											<tr
												key={devices.id}
												className="font-medium h-20 border-b border-gray-200 hover:bg-gray-100"
											>
												<td className="text-center align-middle text-gray-600">
													{devices.device.os}
												</td>
												<td className="text-center align-middle text-gray-600">
													{devices.device.browser}
												</td>
												<td className="text-center align-middle text-gray-600">
													{dateFormat(devices.created_at)}
												</td>
												<td className="text-center align-middle text-gray-600">
													<div className="flex justify-center items-center">
														<Trash2
															className="text-red-500 cursor-pointer trash-icon"
															size={20}
															onClick={() => handleDeleteContact(devices.id)}
														/>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</Content>
			<ModalRoot open={isModalOpen} setIsOpen={setIsModalOpen}>
				<ModalContainer>
					<ModalContent>
						<ModalClose />
						{isSubmitting ? (
							<ModalLoader />
						) : (
							<>
								{step === 1 ? (
									<div className="flex flex-col gap-4 items-center p-4">
										<h3 className="text-[1.875rem] font-semibold text-center">
											Digite seu pin de segurança
										</h3>
										<OTPInputPassword
											length={4}
											formData={otp}
											handleChange={handleOTPPinChange}
											onComplete={onCompletePin}
										/>
									</div>
								) : (
									<div className="flex flex-col gap-4 items-center p-4">
										<img src={successNewPixTransaction} alt="check icon" />
										<p className="text-[1.875rem] font-semibold text-center w-80">
											Dispositivo deletado com sucesso!
										</p>
									</div>
								)}
							</>
						)}
					</ModalContent>
				</ModalContainer>
			</ModalRoot>
		</Container>
	);
}
